import { Box } from '@mui/material'
import React from 'react'

export default function Footer() {
    return (
        <Box sx={{ justifyContent: 'center', position: "static",overflow:'hidden', width: "auto", bottom: 0, alignContent: 'center', padding: 2, backgroundColor: '#2e2838', color: 'white', fontSize: 15 }} >
            ©2024 HPC Nexus.All Rights Reserved.
        </Box >
    )
}
